import axios from 'axios';
import { Toast } from 'vant';
//Get请求
export function GET(url,params={}){
	return new Promise((resolve,reject)=>{
		axios.get(url,{
			params:params
		})
		.then(response=>{
			resolve(response.data)
		})
		.catch(err=>{
			Toast('网络连接出错');
			// reject(err)
		})
	})
}

//Post请求
export function POST(url,data={}){
	return new Promise((resolve,reject)=>{
		axios.post(url,data)
		.then(response=>{
			resolve(response.data)
		})
		.catch(err=>{
			Toast('网络连接出错');
			// reject(err)
		})
	})
}



// WEBPACK FOOTER //
// ./src/http/http.js